// extracted by mini-css-extract-plugin
export default {"viewMode":"Description_viewMode__smpxv"};